import { render } from "./milestone-plan-navigation-bar.vue?vue&type=template&id=44bc1152&scoped=true&ts=true"
import script from "./milestone-plan-navigation-bar.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-navigation-bar.vue?vue&type=script&lang=ts"

import "./milestone-plan-navigation-bar.vue?vue&type=style&index=0&id=44bc1152&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44bc1152"]])

export default __exports__